import { useContext, useMemo } from "react";
import { AuthContext, AuthContextValue } from "./AuthContext";

/**
 * Provides a method for receiving the current authentication token as well as setting the authentication token.
 * @returns A tuple containing the currently logged in session's authentication token or null if not logged in and a function for setting the current authentication token.
 */
export function useAuthToken(): [string | null, AuthContextValue["setAuthToken"]] {
  const { authToken, setAuthToken } = useContext(AuthContext);

  return useMemo<ReturnType<typeof useAuthToken>>(() => {
    return [authToken, setAuthToken];
  }, [authToken, setAuthToken]);
}
